var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":_vm.toggleValidated}},[_vm._v("\n    "+_vm._s(this.isValidated ? this.setUnvalidateLabel : this.setValidateLabel)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }